module.exports = __webpack_public_path__ + "media/Intersitial Round X Screen Alt.40fbc464.mp3";